import { h } from 'preact';
import { useState } from 'preact/hooks';
import SubMenuContainer from './submenu-container';


const MenuItem = ({ link, setShowBackDrop }) => {
  const [subMenuShowed, setSubMenuShowed] = useState(false);


  const showShopAll = link.url !== '#' ? link : false;
  return (
    <li
      key={`${link.title}-${link.url}`}
      className={ `flex items-center h-full border-b-[1.5px] border-transparent hover:border-black min-h-[74px] ${ link.title === 'Holiday Boutique' ? 'text-red' : '' }` }
      onMouseEnter={() => {
        setSubMenuShowed(true);
        setShowBackDrop(true);
      }}
      onMouseLeave={() => {
        setSubMenuShowed(false);
        setShowBackDrop(false);
      }}
    >
      <a
        href={link.url}
        className={
          'utility-1 leading-[1] font-medium tracking-[0.02em] uppercase link-unstyled'
        }
      >
        {link.title}
      </a>
      {link?.submenus?.length > 0 && (
        <SubMenuContainer
          menu={link.submenus}
          subMenuShowed={subMenuShowed}
          showShopAll={showShopAll}
          shopAllTitle={link.title}
        />
      )}
    </li>
  );
};

export default MenuItem;
